import { Box, Grid } from "@mui/material";
import React, { useContext } from "react";
import { RootStoreContext } from "../../store";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import style from "./Team_up.module.css";
import Stack from "@mui/material/Stack";
// import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CustomSCBG from "../../components/button_group/CustomSCBG";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createTeam } from "../../services/TeamService";
import { getAuth } from "firebase/auth";

const auth = getAuth();

const fieldList = [
  "智慧製造",
  "行銷科技",
  "電子商務",
  "資訊安全",
  "人工智慧",
  "教育創新",
  "共享經濟",
  "社會創新",
  "金融科技",
  "旅遊創新",
  "農食創新",
  "生醫/藥/醫材",
  "半導體",
  "數位平台",
  "物聯網IOT",
  "新農業",
  "循環經濟",
  "AR/VR/MR",
  "高齡/照護",
  "文化創意",
  "健身/運動/健康",
  "綠能科技",
  "區塊鏈",
  "智慧零售",
];
const { useState } = React;
function Team_up() {
  const { TeamStore, PersonalStore } = useContext(RootStoreContext);
  const { teamname, field, ideation } = TeamStore;
  const { updateData, updateMembers } = TeamStore;
  const { username, profile_picture } = PersonalStore;
  const [pos, setPos] = useState("");
  const tmpUser = "Eric";
  return (
    <Grid
      container
      className={style.main}
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Box className={style.box}>
        <Stack spacing={5}>
          <div>
            <Typography className={style.formTitle}>團隊名稱</Typography>
            <TextField
              id="outlined-basic"
              // placeholder="布達斯突擊隊"
              variant="outlined"
              className={style.teamNameTF}
              value={teamname}
              onChange={(e) => {
                updateData("teamname", e.target.value);
              }}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>團隊領域</Typography>
            <FormControl className={style.selectField}>
              {/* <InputLabel id="demo-simple-select-helper-label">
              團隊領域
            </InputLabel> */}
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={field}
                // label="Field"
                onChange={(e) => {
                  updateData("field", e.target.value);
                }}
              >
                {fieldList.map((item) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <Typography className={style.formTitle}>團隊理念</Typography>
            <TextField
              id="outlined-basic"
              multiline
              rows={5}
              placeholder="（200字以內）"
              value={ideation}
              onChange={(e) => {
                updateData("ideation", e.target.value);
              }}
              variant="outlined"
              className={style.ideationTF}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>職位選擇</Typography>
            <Box mt={2}>
              <CustomSCBG
                buttons={["執行長", "行銷長", "技術長", "財務長", "設計長"]}
                onChange={(item) => {
                  let members = [
                    { title: "CEO", name: "", img: "", id: "" },
                    { title: "CTO", name: "", img: "", id: "" },
                    { title: "CMO", name: "", img: "", id: "" },
                    { title: "CFO", name: "", img: "", id: "" },
                    { title: "CDO", name: "", img: "", id: "" },
                  ];
                  for (let i = 0; i < members.length; i++) {
                    if (item === members[i].title) {
                      members[i].name = username;
                      members[i].img = profile_picture;
                      members[i].id = auth.currentUser.uid;
                    }
                  }
                  console.log(members);
                  setPos(item);
                  // updateMembers(members);
                  updateData("members", members);
                }}
                extraInfo={tmpUser}
              />
            </Box>
          </div>
        </Stack>
        <Box mt={13}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Link to={"/Teamformation"}>
              <button className={style.cancelBtn}>取消</button>
            </Link>
            <Link to={"/team-1"}>
              <button
                className={style.submitBtn}
                onClick={(e) => {
                  createTeam({
                    teamname: teamname,
                    field: field,
                    ideation: ideation,
                    position: pos,
                  });
                }}
              >
                建立團隊
              </button>
            </Link>
          </Stack>
        </Box>
      </Box>
    </Grid>
  );
}

export default observer(Team_up);
